import api from '@/api/proxyWeb/clients'
import apiMarket from '@/api/proxyWeb/markets'

import { actions } from '@/store/sites'
import { actions as clientActions } from '@/store/clients'

export default {

    get({ commit, dispatch, state }) {

        commit('setCurrentSite', null)

        return new Promise(resolve => {

            Promise.all([                
                dispatch(clientActions.GET_ADDRESSES, null, { root: true }),
                dispatch(actions.GET_MARKETS, null, { root: true })
            ])
            .then( data => {

                let clientAddresses = data[0]
                let markets = data[1]

                clientAddresses.forEach(clientAddress => {
                    if ( parseInt(clientAddress.site.id) ===  state.currentId ) {
                        commit('setCurrentSite', clientAddress)
                        resolve(clientAddress)
                    }
                })

                markets.forEach(market => {
                    if ( parseInt(market.site.id) ===  state.currentId ) {
                        commit('setCurrentSite', market)
                        resolve(market)
                    }
                })

                resolve(null)
            })                
        }); 
    },

    getAll({ commit, rootState }) {

        commit('setSites', [])        

        return new Promise(resolve => {
            
            api.getAddresses(rootState.clients.currentId)
                .then(addresses => {
                    commit('setSites', addresses)
                    resolve(addresses)
                })
            })
    },

    getMarkets({ commit }) {

        commit('setMarkets', [])
        
        return new Promise(resolve => {
            
            apiMarket.list()
                .then(markets => {
                    commit('setMarkets', markets)
                    resolve(markets)
                })
            })
    }
}